<ion-content class="ion-padding">
    <ion-list>
        <ion-radio-group>
            <ion-item button *ngFor="let place of places" (click)="onClickPlace(place)">
                <ion-label>
                    <h3>{{ place.label }}</h3>
                    <p>{{ place.address }}</p>
                </ion-label>
                <ion-radio [value]="place.id"></ion-radio>
            </ion-item>
        </ion-radio-group>
    </ion-list>

</ion-content>